import './search.css'
import { useLanguage } from '../../i18n/LanguageContext'

const GROUPS = [
  {
    labelKey: 'filter.standard',
    values: ['Standard'],
    subLabelKeys: ['filter.standard'],
  },
  {
    labelKey: 'filter.fast',
    values: ['Fast 8', 'Fast 9'],
    subLabelKeys: ['filter.fast8', 'filter.fast9'],
  },
  {
    labelKey: 'filter.slowRoll',
    values: ['Slow Roll (5)', 'Slow Roll (6)', 'Slow Roll (7)'],
    subLabelKeys: ['filter.slowRoll5', 'filter.slowRoll6', 'filter.slowRoll7'],
  },
]

export default function PlayStyleFilter({ active, onChange }) {
  const { t } = useLanguage()
  const handleGroupClick = (group) => {
    const allActive =
      active &&
      group.values.every((v) => active.includes(v)) &&
      active.length === group.values.length
    onChange(allActive ? null : group.values)
  }

  const handleSubClick = (e, value) => {
    e.stopPropagation()
    const alreadyExact = active && active.length === 1 && active[0] === value
    onChange(alreadyExact ? null : [value])
  }

  return (
    <div className="play-style-filter">
      {GROUPS.map((group) => {
        const isActive = active && group.values.some((v) => active.includes(v))
        const hasSubOptions = group.values.length > 1

        return (
          <div key={group.labelKey} className="pill-group">
            <button
              className={`style-pill ${isActive ? 'active' : ''}`}
              onClick={() => handleGroupClick(group)}
            >
              {t(group.labelKey)}
              {hasSubOptions && <span className="pill-caret">▾</span>}
            </button>
            {hasSubOptions && (
              <div className="pill-dropdown">
                {group.values.map((value, i) => {
                  const isSubActive =
                    active && active.length === 1 && active[0] === value
                  return (
                    <button
                      key={value}
                      className={`style-pill sub-pill ${isSubActive ? 'active' : ''}`}
                      onClick={(e) => handleSubClick(e, value)}
                    >
                      {t(group.subLabelKeys[i])}
                    </button>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
